


// Functions
import * as Functions from '../functions/common';

// models
import { VisitTypeEnum } from "../models/Enums/VisitTypeEnum";
import { PractitionerConsumption } from "../models/Entities/Practitioners/PractitionerConsumption";
import { NewPractitionerConsumption } from "../models/Entities/Practitioners/NewPractitionerConsumption";
import { IResult } from "../models/HttpResult";
import { PractitionerConsumptionTotal } from '../models/Entities/Practitioners/PractitionerConsumptionTotal';
import { IPagedResult } from '../models/HttpPagedResult';
import { IConsumptionsFilters } from '../models/Filters/ConsumptionsFilters';

// Base URL
const BaseURL = process.env.REACT_APP_BILLER_API_GATEWAY + 'protocols/practitioners/';

// Interface for practitioner consumption filters
interface PractitionerConsumptionFilters {
    searchText?: string;
    concepts?: number[];
    currencies?: string[];
    patients?: string[];
    practitioners?: string[];
    protocols?: number[];
    stagesName?: string[];
    statuses?: number[];
}

// add method to get all practitioners consumptions
export const GetAllConsumptionByPractitionerId = async (
    token: string,
    practitioner: string,
    pageNumber: number,
    pageSize: number,
    filters?: IConsumptionsFilters
): Promise<IPagedResult<PractitionerConsumption[]>> => {

     let params: URLSearchParams = Functions.GetQueryStringParams(
            pageNumber,
            pageSize,
            filters?.FilterText,
            filters
        );

    let RequestURL: string = BaseURL + practitioner + '/consumptions';

    if (params) RequestURL += '?' + params.toString();

    try {
        const Response: IPagedResult<PractitionerConsumption[]> = await fetch(RequestURL, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token
            },
            method: 'GET'
        })
        .then((response) => {
            if (!response.ok) {
            throw response;
            } else {
            return response.json() as Promise<IPagedResult<PractitionerConsumption[]>>;
            }
        })
        .then((data: IPagedResult<PractitionerConsumption[]>) => {
            return data;
        })
        .catch((error: any) =>
            error.text().then((body: any) => {
            throw Functions.HttpErrorHandler(body, error);
            })
        );

        return Response;
    } catch (error: any) {
        throw error;
    }
};

// get practitioners consumption by id
export const GetPractitionerConsumptionById = async (
    token: string,
    id: string
): Promise<PractitionerConsumption> => {
    let RequestURL: string = BaseURL + '/consumptions/' + id;
    try {
        const Response: PractitionerConsumption = await fetch(RequestURL, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token
        },
        method: 'GET'
        })
        .then((response) => {
            if (!response.ok) {
            throw response;
            } else {
            return response.json() as Promise<IResult<PractitionerConsumption>>;
            }
        })
        .then((data: IResult<PractitionerConsumption>) => {
            return data.data;
        })
        .catch((error: any) =>
            error.text().then((body: any) => {
            throw Functions.HttpErrorHandler(body, error);
            })
        );

        return Response;
    } catch (error: any) {
        throw error;
    }
};

// get totals by status
export const GetPractitionerConsumptionTotals = async (
    practitionerId: string,
    status: number,
    token: string
): Promise<PractitionerConsumptionTotal[]> => {
    let RequestURL: string = BaseURL + practitionerId + '/consumptions/totals?status=' + status;
    try {
        const Response: PractitionerConsumptionTotal[] = await fetch(RequestURL, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token
        },
        method: 'GET'
        })
        .then((response) => {
            if (!response.ok) {
            throw response;
            } else {
            return response.json() as Promise<IResult<PractitionerConsumptionTotal[]>>;
            }
        })
        .then((data: IResult<PractitionerConsumptionTotal[]>) => {
            return data.data;
        })
        .catch((error: any) =>
            error.text().then((body: any) => {
            throw Functions.HttpErrorHandler(body, error);
            })
        );

        return Response;
    } catch (error: any) {
        throw error;
    }
};

// create practitioners consumption
export const CreatePractitionerConsumption = async (
    token: string,
    practitionerConsumption: NewPractitionerConsumption
): Promise<PractitionerConsumption> => {
    let RequestURL: string = BaseURL + 'consumptions/';
    try {
        const Response: PractitionerConsumption = await fetch(RequestURL, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token
        },
        method: 'POST',
        body: JSON.stringify(practitionerConsumption)
        })
        .then((response) => {
            if (!response.ok) {
            throw response;
            } else {
            return response.json() as Promise<IResult<PractitionerConsumption>>;
            }
        })
        .then((data: IResult<PractitionerConsumption>) => {
            return data.data;
        })
        .catch((error: any) =>
            error.text().then((body: any) => {
            throw Functions.HttpErrorHandler(body, error);
            })
        );

        return Response;
    } catch (error: any) {
        throw error;
    }
};

// update practitioners consumption
export const UpdatePractitionerConsumption = async (
    token: string,
    practitionerConsumption: PractitionerConsumption
): Promise<PractitionerConsumption> => {
    let RequestURL: string = BaseURL + '/consumptions/';
    try {
        const Response: PractitionerConsumption = await fetch(RequestURL, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token
        },
        method: 'PUT',
        body: JSON.stringify(practitionerConsumption)
        })
        .then((response) => {
            if (!response.ok) {
            throw response;
            } else {
            return response.json() as Promise<IResult<PractitionerConsumption>>;
            }
        })
        .then((data: IResult<PractitionerConsumption>) => {
            return data.data;
        })
        .catch((error: any) =>
            error.text().then((body: any) => {
            throw Functions.HttpErrorHandler(body, error);
            })
        );

        return Response;
    } catch (error: any) {
        throw error;
    }
};

// delete practitioners consumption
export const DeletePractitionerConsumption = async (
    token: string,
    id: string
): Promise<PractitionerConsumption> => {
    let RequestURL: string = BaseURL + 'consumptions/' + id;
    try {
        const Response: PractitionerConsumption = await fetch(RequestURL, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token
        },
        method: 'DELETE'
        })
        .then((response) => {
            if (!response.ok) {
            throw response;
            } else {
            return response.json() as Promise<IResult<PractitionerConsumption>>;
            }
        })
        .then((data: IResult<PractitionerConsumption>) => {
            return data.data;
        })
        .catch((error: any) =>
            error.text().then((body: any) => {
            throw Functions.HttpErrorHandler(body, error);
            })
        );

        return Response;
    } catch (error: any) {
        throw error;
    }
};

// change practitioners consumption status
export const ChangePractitionerConsumptionStatus = async (
    token: string,
    practitionerId: string,
    consumptionId: string,
    status: number,
    applyToAll: boolean
): Promise<PractitionerConsumption> => {
    let RequestURL: string = BaseURL + 'consumptions/' + 
    consumptionId + '?newStatus=' + status + '&PractitionerId' + practitionerId + '&applyToAll=' + applyToAll;
    try {
        const Response: PractitionerConsumption = await fetch(RequestURL, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token
        },
        method: 'PATCH'
        })
        .then((response) => {
            if (!response.ok) {
            throw response;
            } else {
            return response.json() as Promise<IResult<PractitionerConsumption>>;
            }
        })
        .then((data: IResult<PractitionerConsumption>) => {
            return data.data;
        })
        .catch((error: any) =>
            error.text().then((body: any) => {
            throw Functions.HttpErrorHandler(body, error);
            })
        );

        return Response;
    } catch (error: any) {
        throw error;
    }
};

// change practitioners consumption concept

export const SetConsumptionConcept = async (
    token: string,
    consumptionId: string,
    conceptId: number,
    changeAll: boolean
): Promise<PractitionerConsumption[]> => {

    /*
    example url
    -> consumption/3fa85f64-5717-4562-b3fc-2c963f66afa6/concept/12?ChangeAll=false
    */
    let RequestURL: string = BaseURL + 'consumptions/' + consumptionId + '/concept/' + conceptId + '?ChangeAll=' + changeAll;
    try {
        const Response: PractitionerConsumption[] = await fetch(RequestURL, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token
        },
        method: 'PATCH'
        })
        .then((response) => {
            if (!response.ok) {
            throw response;
            } else {
            return response.json() as Promise<IResult<PractitionerConsumption[]>>;
            }
        })
        .then((data: IResult<PractitionerConsumption[]>) => {
            return data.data;
        })
        .catch((error: any) =>
            error.text().then((body: any) => {
            throw Functions.HttpErrorHandler(body, error);
            })
        );

        return Response;
    } catch (error: any) {
        throw error;
    }
}

// change practitioners consumption producer 

export const SetConsumptionProducer = async (
    token: string,
    consumptionId: string,
    producerId: string
): Promise<PractitionerConsumption[]> => {

    /*
    example url
    -> consumption/3fa85f64-5717-4562-b3fc-2c963f66afa6/producer/12
    */
    let RequestURL: string = BaseURL + 'consumptions/' + consumptionId + '/producer/' + producerId;
    try {
        const Response: PractitionerConsumption[] = await fetch(RequestURL, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token
        },
        method: 'PATCH'
        })
        .then((response) => {
            if (!response.ok) {
            throw response;
            } else {
            return response.json() as Promise<IResult<PractitionerConsumption[]>>;
            }
        })
        .then((data: IResult<PractitionerConsumption[]>) => {
            return data.data;
        })
        .catch((error: any) =>
            error.text().then((body: any) => {
            throw Functions.HttpErrorHandler(body, error);
            })
        );

        return Response;
    } catch (error: any) {
        throw error;
    }
}


// change amount of practitioners consumption
    
export const SetConsumptionAmount = async (
    token: string,
    consumptionId: string,
    amount: number,
    currencyCode: string
): Promise<PractitionerConsumption> => {

    /*
    example url
    -> consumption/3fa85f64-5717-4562-b3fc-2c963f66afa6/amount?newAmount=1500&currency=ARS
    */
    let RequestURL: string = BaseURL + 'consumptions/' + consumptionId + '/amount?newAmount=' + amount + '&currency=' + currencyCode;
    try {
        const Response: PractitionerConsumption = await fetch(RequestURL, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token
        },
        method: 'PATCH'
        })
        .then((response) => {
            if (!response.ok) {
            throw response;
            } else {
            return response.json() as Promise<IResult<PractitionerConsumption>>;
            }
        })
        .then((data: IResult<PractitionerConsumption>) => {
            return data.data;
        })
        .catch((error: any) =>
            error.text().then((body: any) => {
            throw Functions.HttpErrorHandler(body, error);
            })
        );

        return Response;
    } catch (error: any) {
        throw error;
    }
};

export const SetConsumptionRate = async (
    token: string,
    consumptionId: string,
    rate: number,
    currencyCode: string
): Promise<string> => {

    // example url
    // -> consumptions/{id}/rate
    let RequestURL: string = BaseURL + 'consumptions/' + consumptionId + '/rate';
    try {
        const Response: string = await fetch(RequestURL, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token
        },
        method: 'POST',
        body: JSON.stringify({
            id: consumptionId,
            rate: rate,
            currencyCode: currencyCode
        })
        })
        .then((response) => {
            if (!response.ok) {
            throw response;
            } else {
            return response.json() as Promise<IResult<string>>;
            }
        })
        .then((data: IResult<string>) => {
            return data.data;
        })
        .catch((error: any) =>
            error.text().then((body: any) => {
            throw Functions.HttpErrorHandler(body, error);
            })
        );

        return Response;
    } catch (error: any) {
        throw error;
    }
};

export const SetConsumptionRateBySettlementId = async (
    token: string,
    settlementId: number,
    rate: number,
    currencyCode: string
): Promise<string> => {
    // endpoint expected when API supports settlement-wide rate update
    // -> consumptions/settlements/{settlementId}/rate
    let RequestURL: string = BaseURL + 'consumptions/settlements/' + settlementId + '/rate';
    try {
        const Response: string = await fetch(RequestURL, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token
        },
        method: 'POST',
        body: JSON.stringify({
            settlementId: settlementId,
            rate: rate,
            currencyCode: currencyCode
        })
        })
        .then((response) => {
            if (!response.ok) {
            throw response;
            } else {
            return response.json() as Promise<IResult<string>>;
            }
        })
        .then((data: IResult<string>) => {
            return data.data;
        })
        .catch((error: any) =>
            error.text().then((body: any) => {
            throw Functions.HttpErrorHandler(body, error);
            })
        );

        return Response;
    } catch (error: any) {
        throw error;
    }
};

// change visit type
export const SetConsumptionVisitType = async (
    token: string,
    consumptionId: string,
    visitTypeId: VisitTypeEnum
): Promise<PractitionerConsumption> => {

    /*
    example url
    -> protocols/consumptions/3fa85f64-5717-4562-b3fc-2c963f66afa6/type/1
    */
    let RequestURL: string = BaseURL + 'consumptions/' + consumptionId + '/visitType/' + visitTypeId;
    try {
        const Response: PractitionerConsumption = await fetch(RequestURL, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token
        },
        method: 'PATCH'
        })
        .then((response) => {
            if (!response.ok) {
            throw response;
            } else {
            return response.json() as Promise<IResult<PractitionerConsumption>>;
            }
        })
        .then((data: IResult<PractitionerConsumption>) => {
            return data.data;
        })
        .catch((error: any) =>
            error.text().then((body: any) => {
            throw Functions.HttpErrorHandler(body, error);
            })
        );

        return Response;
    } catch (error: any) {
        throw error;
    }
};

export const GetPractitionerConsumptionByStatus = async (
    practitionerId: string,
    status: number,
    token: string): Promise<PractitionerConsumption[]> => {

    if (!token) {
        throw new Error('No access token found');
    }

    let RequestURL: string = BaseURL + practitionerId + '/consumptions/status/' + status;
    
    try {
        const Response: PractitionerConsumption[] = await fetch(RequestURL, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token
            },
            method: 'GET'
        })
        .then((response) => {
            if (!response.ok) {
                throw response;
            } else {
                return response.json() as Promise<IResult<PractitionerConsumption[]>>;
            }
        })
        .then((data: IResult<PractitionerConsumption[]>) => {
            return data.data;
        })
        .catch((error: any) =>
            error.text().then((body: any) => {
                throw Functions.HttpErrorHandler(body, error);
            })
        );

        return Response;
    } catch (error: any) {
        throw error;
    }
};

// add method to export to excel practitioners consumptions
export const ExportConsumptionByPractitionerId = async (
    token: string,
    filters: IConsumptionsFilters,
    practitionerId: string
): Promise<Blob> => {

     let params: URLSearchParams = Functions.GetQueryStringParams(
        undefined,
        undefined,
        filters.FilterText,
        filters
    );

    let RequestURL: string = BaseURL + practitionerId + '/consumptions/export';

    if (params) RequestURL += '?' + params.toString();

    try {
        const Response: Blob = await fetch(RequestURL, {
            headers: {
                Accept: 'application/json',
                Authorization: 'Bearer ' + token
            },
            method: 'GET'
        })
        .then((response) => {
            if (!response.ok) {
            throw response;
            } else {
            return response.blob() as Promise<Blob>;
            }
        })
        .then((data: Blob) => {
            return data;
        })
        .catch((error: any) =>
            error.text().then((body: any) => {
            throw Functions.HttpErrorHandler(body, error);
            })
        );

        return Response;
    } catch (error: any) {
        throw error;
    }
};